import React from 'react';

export interface AtrasIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const AtrasIcon: React.FC<AtrasIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15.334 18.662-6-6 6-6"/>
    </svg>
  );
};

export default AtrasIcon;
